import { Routes, Route } from 'react-router-dom';
import Shop from './Shop/Shop';
import Admin from './Admin/Admin';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
import AuthContextProvider from './context/AuthContext/AuthContext';
import HistoryContextProvider from './context/HistoryContext/HistoryContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import CartContextProvider from './context/CartContext/CartContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NotFoundUser from './pages/NotFound/NotFoundUser';
import NotFoundAdmin from './pages/NotFound/NotFoundAdmin';

function App() {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 5,
        cacheTime: 1000 * 60 * 5
      }
    }
  });

  return (
    <div>
      <QueryClientProvider client={client}>
        <AuthContextProvider>
          <HistoryContextProvider>
            {/* The public-facing cart provider for guests and regular users */}
            <CartContextProvider storageKey="cart_token">
              <Routes>
                <Route path="/register" element={<Register />} />
                <Route path="/login" element={<Login />} />
                <Route path="/*" element={<Shop />} />
                <Route path="*" element={<NotFoundUser />} />
                <Route
                  element={
                    <ProtectedRoute
                      gate={(user) => {
                        return (
                          !!user &&
                          typeof user.hasAnyRole === 'function' &&
                          user.hasAnyRole(['super-admin'])
                        );
                      }}
                    />
                  }
                >
                  {/* The Admin section gets its own, isolated Cart Provider */}
                  <Route
                    path="/admin/*"
                    element={
                      <CartContextProvider storageKey="admin_cart_token">
                        <Admin />
                      </CartContextProvider>
                    }
                  />
                </Route>
                <Route path="*" element={<NotFoundAdmin />} />
              </Routes>
            </CartContextProvider>
          </HistoryContextProvider>
        </AuthContextProvider>
      </QueryClientProvider>

      <ToastContainer
        className="cs-toast-wrapper"
        theme="dark"
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
